import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/migren-tedavisinde-botoks-bilimsel-ve-klinik-yaklasim/page.tsx");
